import { create } from 'zustand'
import { rolesApi, type RolesCatalog } from '../services/rolesApi'

// Справочник ролей с сервера. Роли и права редактируются в настройках, поэтому
// держать их зашитыми в коде интерфейса больше нельзя: подписи и видимость
// кнопок берутся отсюда.
interface RolesState {
    catalog: RolesCatalog | null
    // Растёт при каждой загрузке: по нему приложение перерисовывается, когда
    // справочник пришёл или поменялся.
    version: number
    load: () => Promise<void>
}

export const useRolesStore = create<RolesState>((set) => ({
    catalog: null,
    version: 0,
    load: async () => {
        const { data } = await rolesApi.catalog()
        set((state) => ({ catalog: data, version: state.version + 1 }))
    },
}))
